import { createSlice } from '@reduxjs/toolkit'


export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: {
    navigation: {
      sidePanel: 'text',
    },
    fileName: 'Untitled Design',
    loadStore: null,
    alwaysApplyToAll: false,
    // Sync mode: 'strict' | 'smart' | 'loose'
    syncMode: 'strict',
    // Brand palette colors (locked from changes)
    brandPalette: [],
    // Timestamp of last Smart mode usage
    lastSmartModeUsed: null,
  },
  reducers: {
    setSidePanel: (state, action) => {
      state.navigation.sidePanel = action.payload
    },
    setFileName: (state, action) => {
      state.fileName = action.payload
    },
    setLoadStore: (state, action) => {
      state.loadStore = action.payload
    },
    setAlwaysApplyToAll: (state, action) => {
      state.alwaysApplyToAll = action.payload
    },
    setSyncMode: (state, action) => {
      state.syncMode = action.payload
    },
    setBrandPalette: (state, action) => {
      state.brandPalette = action.payload
    },
    addBrandColor: (state, action) => {
      if (!state.brandPalette.includes(action.payload)) {
        state.brandPalette.push(action.payload)
      }
    },
    removeBrandColor: (state, action) => {
      state.brandPalette = state.brandPalette.filter(c => c !== action.payload)
    },
    setLastSmartModeUsed: (state, action) => {
      state.lastSmartModeUsed = action.payload
    },
    clearStore: (state) => {
      state.loadStore = null
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setSidePanel,
  setFileName,
  setLoadStore,
  setAlwaysApplyToAll,
  setSyncMode,
  setBrandPalette,
  addBrandColor,
  removeBrandColor,
  setLastSmartModeUsed,
  clearStore,
} = preferencesSlice.actions

export default preferencesSlice.reducer